<template>
  <div id="documents-container" class="container">
    <nav class="navbar navbar-default navbar-fixed-top"
      :style="$mq === 'desktop' ? `top: ${$root.desktopHeaderSize};` : `top: ${$root.mobileHeaderSize};`">
      <div class="container-fluid">
        <div class="navbar-header">
          <h1 class="navbar-brand"><span v-html="$root.domainTrademark"></span> Documents</h1>
        </div>

        <div id="menu">
          <ul class="nav navbar-nav documents-nav" v-show="$mq === 'desktop'">
            <li id="sds" :class="selectedSection === 'sds' ? 'active' : ''" @click="isActive($event)" v-show="showSDS">
              <button class="btn btn-default navbar-btn" href="#">Safety Data Sheets</button>
            </li>
            <li id="ag" :class="selectedSection === 'ag' ? 'active' : ''" @click="isActive($event)"
              v-show="showAppGuide">
              <button class="btn btn-default navbar-btn" href="#">Application Guides</button>
            </li>
            <li id="pt" :class="selectedSection === 'pt' ? 'active' : ''" @click="isActive($event)"
                v-show="showProductTests">
              <button class="btn btn-default navbar-btn" href="#">Product Testing</button>
            </li>
            <li id="om" :class="selectedSection === 'om' ? 'active' : ''" @click="isActive($event)" v-show="showOther">
              <button class="btn btn-default navbar-btn" href="#">Other Media</button>
            </li>
          </ul>
          <form class="navbar-form navbar-right">
            <div class="form-group">
              <input type="text" class="form-control" placeholder="Search documents" v-model="searchText">
            </div>
            <button type="submit" :class="`btn btn-${searchText ? 'primary' : 'default'}`"
              @click.prevent="searchDocuments()" :disabled="!searchText">Submit</button>
          </form>
        </div>

      </div>
    </nav>

    <transition name="fade">
      <div v-show="!loading">
        <div id="search" class="document-section" v-if="showSearchResults">
          <h2>Search Results&nbsp;<span class="badge">{{ searchedDocuments.length }}</span></h2>
          <div class="col-sm-12">
            <div class="row well documentList">
              <div v-if="!searchedDocuments.length" class="col-sm-12">
                No documents found
              </div>
              <div class="doc-item" v-for="document in searchedDocuments" v-if="document.media_resource">
                <button :id="document.id"
                  :title="`${loggedIn ? 'Add' : 'Login to add'} this document to your favorites`"
                  @click="!favorites.includes(document.id) ? saveDocument(document) : unsaveDocument(document);"
                  :disabled="!loggedIn">
                  <i :class="`fa fa-star${favorites.includes(document.id) ? '' : '-o'}`" aria-hidden="true"></i>
                </button>
                <a :href="document.media_resource.content_url" target="_blank">
                  <i class="fa fa-question-circle" aria-hidden="true"></i> {{ document.name }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="safety-data-sheets" class="document-section" v-show="showSDS" ref="sds">
          <h2>Safety Data Sheets&nbsp;<span class="badge">{{ SDS.length }}</span></h2>
          <div class="well col-sm-12">
            <div class="doc-item" v-for="document in SDS" v-if="document.media_resource" :key="document.id">
              <button :id="document.id" :title="`${loggedIn ? 'Add' : 'Login to add'} this document to your favorites`"
                @click="!favorites.includes(document.id) ? saveDocument(document) : unsaveDocument(document);"
                :disabled="!loggedIn">
                <i :class="`fa fa-star${favorites.includes(document.id) ? '' : '-o'}`" aria-hidden="true"></i>
              </button>
              <a :href="document.media_resource.content_url">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{ document.name }}
              </a>
            </div>
          </div>
        </div>

        <div id="application-guides" class="document-section" v-show="showAppGuide" ref="ag">
          <h2>Application Guides&nbsp;<span class="badge">{{ appGuide.length }}</span></h2>
          <div class="well col-sm-12">
            <div class="doc-item" v-for="document in appGuide" v-if="document.media_resource">
              <button :id="document.id" :title="`${loggedIn ? 'Add' : 'Login to add'} this document to your favorites`"
                @click="!favorites.includes(document.id) ? saveDocument(document) : unsaveDocument(document);"
                :disabled="!loggedIn">
                <i :class="`fa fa-star${favorites.includes(document.id) ? '' : '-o'}`" aria-hidden="true"></i>
              </button>
              <a :href="document.media_resource.content_url">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{ document.name }}
              </a>
            </div>
          </div>
        </div>

        <div id="product-testing" class="document-section" v-show="showProductTests" ref="pt">
          <h2>Product Testing&nbsp;<span class="badge">{{ productTests.length }}</span></h2>
          <div class="well col-sm-12">
            <div class="doc-item" v-for="document in productTests" v-if="document.media_resource">
              <button :id="document.id" :title="`${loggedIn ? 'Add' : 'Login to add'} this document to your favorites`"
                      @click="!favorites.includes(document.id) ? saveDocument(document) : unsaveDocument(document);"
                      :disabled="!loggedIn">
                <i :class="`fa fa-star${favorites.includes(document.id) ? '' : '-o'}`" aria-hidden="true"></i>
              </button>
              <a :href="document.media_resource.content_url">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{ document.name }}
              </a>
            </div>
          </div>
        </div>

        <div id="other-media" class="document-section" v-show="showOther" ref="om">
          <h2>Other Media&nbsp;<span class="badge">{{ otherDocs.length }}</span></h2>
          <div class="well col-sm-12">
            <div class="doc-item" v-for="document in otherDocs" v-if="document.media_resource">
              <button :id="document.id" :title="`${loggedIn ? 'Add' : 'Login to add'} this document to your favorites`"
                @click="!favorites.includes(document.id) ? saveDocument(document) : unsaveDocument(document);"
                :disabled="!loggedIn">
                <i :class="`fa fa-star${favorites.includes(document.id) ? '' : '-o'}`" aria-hidden="true"></i>
              </button>
              <a :href="document.media_resource.content_url">
                <i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{ document.name }}
              </a>
            </div>
          </div>
        </div>

      </div>
    </transition>

    <transition name="fade">
      <div id="loading-documents" v-show="loading">
        <div class="loading-contents">
          <h1>Loading...</h1>
          <i class="fa fa-spin fa-spinner"></i>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
/**
 * @description This is the Vue component for the document list.
 * @todo The <template> could be further refactored to only use one div section
 * and loop through to create each section, or, these could be split into a reuseable child component.
 * Time/complexity tradeoff.
 */

import axios from 'axios';
import helpers from '../../../mixins/helpers.js';

export default {
  name: 'documents',

  mixins: [helpers],

  data() {
    return {
      documents: [],
      myDocuments: [],
      favorites: [],
      searchText: '',
      searchedDocuments: [],
      loading: false,
      showSearchResults: false,
      showTechSheets: false,
      showSDS: false,
      showOther: false,
      showAppGuide: false,
      showProductTests: false,
      // starting tab/button
      selectedSection: 'sds',
      // types of documents
      types: [
        {
          name: 'other',
          limit: 50,
        },
        {
          name: 'sds',
          limit: 50,
        },
        {
          name: 'appGuide',
          limit: 50,
        },
        {
          name: 'tds',
          limit: 150,
        },
        {
          name: 'productTests',
          limit: 50,
        },
      ],
      // api docs endpoint url (GET)
      documentsApiUrl: `/api/proxify/domains/${this.$root.domain}/documents`,
      // api docs me endpoint url (GET, POST, DELETE)
      documentsMeApiUrl: '/api/proxify/me/documents',
    };
  },

  computed: {
    loggedIn() {
      return this.$root.isLoggedIn;
    },

    SDS() {
      if (this.documents.filter(e => e.type === 'sds').length > 0) {
        this.showSDS = true;
      }

      return this.documents.filter(e => e.type === 'sds');
    },

    TDS() {
      if (this.documents.filter(e => e.type === 'tds').length > 0) {
        this.showTechSheets = true;
      }

      return this.documents.filter(e => e.type === 'tds');
    },

    appGuide() {
      if (this.documents.filter(e => e.type === 'appGuide').length > 0) {
        this.showAppGuide = true;
      }

      return this.documents.filter(e => e.type === 'appGuide');
    },

    productTests() {
      if (this.documents.filter(e => e.type === 'productTests').length > 0) {
        console.log('showing products')
        this.showProductTests = true;
      }

      console.log('now returning filtered documents')
      return this.documents.filter(e => e.type === 'productTests');
    },

    otherDocs() {
      if (this.documents.filter(e => e.type === 'other').length > 0) {
        this.showOther = true;
      }

      return this.documents.filter(e => e.type === 'other');
    },
  },

  created() {
    this.loading = true;

    // fetches all document types from the api
    this.getDocuments();
  },

  watch: {
    'loggedIn': function () {
      axios.get(this.documentsMeApiUrl)
        .then(response => {
          this.myDocuments = response.data;
          this.favorites = response.data.map(document => document.id);
        })
        .catch(error => {
          console.log(error);
        });
    },
  },

  methods: {
    /**
     * @function getDocuments
     * @description loops through the types array and returns documents for each type.
     * @returns {void}
     */
    async getDocuments() {
      for (const type of this.types) {
        // api fields to return
        const fields = 'id,name,description,type,media_resource.content_url';
        // fetch documents for each type
        const { data: response } = await axios.get(this.documentsApiUrl, {
          params: {
            limit: type.limit,
            type: type.name,
            fields: fields,
          }, // end params
        }); // end axios
        // add documents to the documents array
        await Promise.all(response.data.map(async (document) => {
          this.documents.push(document);
        })) // end Promise.all
          .catch(error => {
            if (error) {
              this.$root.$refs.notifications.add({
                delay: false,
                type: "error",
                icon: "exclamation-triangle",
                title: "Unable to fetch documents",
                message: `Please try again later.`
              });
            }
          }); // end Promise.all
      }

      // delay loading until all documents are fetched
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    /**
     * @function isActive
     * @description returns an active id if the section is selected and scrolls to the section
     * @param {event} event - the event that triggered the function
     */
    isActive(event) {
      this.selectedSection = event.currentTarget.id;
      this.scroll(event);
    },

    scroll(el) {
      let $element = $(this.$refs[el.currentTarget.id]);
      let offset = $element.position().top;
      let height = $element.outerHeight();

      this.scrollToPosition((offset + height) - 240);
    },

    searchDocuments() {
      let vm = this;
      let queryParams = {};

      vm.loading = true;

      if (vm.searchText.length) {
        queryParams.q = vm.searchText;
      } else {
        vm.showSearchResults = false;
        return;
      }

      axios.get(this.documentsApiUrl, {
        params: queryParams
      }).then(({ data: response }) => {
        vm.showSearchResults = true;
        vm.searchedDocuments = response.data;
      }).catch(error => {
        console.log(error);
      });

      $('html, body').animate({
        scrollTop: 0
      }, 500);

      vm.loading = false;
    },

    saveDocument(document) {
      let vm = this;
      let userDocUrl = `${this.documentsMeApiUrl}/${document.id}`;

      axios.put(userDocUrl)
        .then(({ data: response }) => {
          vm.favorites.push(document.id);
        })
        .catch(error => {
          console.log(error);
        });
    },

    unsaveDocument(document) {
      let vm = this;
      let userDocUrl = `${this.documentsMeApiUrl}/${document.id}`;

      axios.delete(userDocUrl)
        .then(({ data: response }) => {
          vm.favorites = vm.favorites.filter(e => e !== document.id);
        })
        .catch(error => {
          console.log(error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
#documents-container {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  margin-top: 1%;

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  #loading-documents {
    font-size: 60px;
    text-align: center;
    position: relative;
    height: 15vh;

    .loading-contents {
      width: 100%;
      position: absolute;
      z-index: 10;
      background-color: #fff;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
    }
  }

  .navbar-fixed-top {
    z-index: 1;
    padding: 5px;

    .navbar-brand {
      margin: auto;
    }

    .navbar-btn {
      margin: auto 5px;
    }

    .container-fluid {
      justify-content: center;
      display: inline-flex;
      width: 100%;
    }
  }

  .documents-nav {
    margin-top: 10px;
  }

  .document-section,
  .documentList {
    h2 {
      display: inline-flex;
      align-items: center;

      span {
        display: inline-block;
      }
    }

    .doc-item {
      font-size: 1.8rem;
      margin: 3px 0;
    }
  }
}

@media (max-width: 1199px) {
  .container-fluid {
    .navbar-form {
      display: inline-flex;
      border: none;
      margin: 5px;
      padding: 0;
    }

    button {
      margin: 0 0 5px 5px;
    }
  }
}

@media (max-width: 767px) {
  .navbar-header {
    h1 {
      display: none;
    }
  }
}
</style>
